"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1292],{

/***/ 11292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/hooks/index.js + 13 modules
var hooks = __webpack_require__(98702);
;// CONCATENATED MODULE: ./src/snippets/account/LoginForm/LoginForm.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function LoginForm(param) {
    var setAction = param.setAction;
    var ref, ref1;
    var ref2 = (0,dist.useCustomerLogin)(), customerLogin = ref2.customerLogin, started = ref2.started, finished = ref2.finished, errors = ref2.errors, success = ref2.success, reset = ref2.reset, resetTimer = ref2.resetTimer;
    var sendLogInEvent = (0,hooks/* useDataLayerActions */.KZ)().sendLogInEvent;
    var settings = (0,dist.useSettings)();
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                reset && reset();
                clearTimeout(resetTimer.current);
            }, 2500);
        }
        return finished ? success ? "Signed In" : "Failed" : started ? "Signing in..." : "Sign In";
    }, [
        started,
        success,
        finished
    ]);
    var loginHandler = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var _target, email, password;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        _target = event.target, email = _target.email, password = _target.password;
                        _ctx.next = 4;
                        return customerLogin({
                            email: email.value,
                            password: password.value
                        });
                    case 4:
                        sendLogInEvent();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loginHandler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-6 py-[50px] lg:py-20",
        children: [
            (settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.SignInMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mb-6 max-w-[325px] md:max-w-[430px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-start justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "mt-1 h-4 w-4",
                            src: "/images/success-icon.png",
                            width: "16",
                            height: "16"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "m-0 pl-2 text-center text-teal-50",
                            children: settings === null || settings === void 0 ? void 0 : (ref1 = settings.account) === null || ref1 === void 0 ? void 0 : ref1.SignInMessage
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto w-full max-w-[325px] text-center",
                onSubmit: loginHandler,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-3 lg:mb-4",
                        children: "Sign In"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-small mb-7 font-light lg:text-base",
                        children: [
                            "Don\u2019t have an account? ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/account/register",
                                children: "Create one now."
                            })
                        ]
                    }),
                    (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mb-[22px] w-full px-7 py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute inset-0 h-full w-full bg-error opacity-10"
                            }),
                            errors.map(function(err) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-0 text-[14px] leading-5 text-error",
                                    children: err === "Unidentified customer" ? "Incorrect email / password" : "Something went wrong. Please try again."
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-field mb-[22px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "loginEmail",
                                placeholder: " ",
                                name: "email",
                                type: "email",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "loginEmail",
                                children: " Email Address "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-field mb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "loginPassword",
                                placeholder: " ",
                                name: "password",
                                type: "password",
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "loginPassword",
                                children: " Password "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: "button button--primary mb-[22px] w-[225px]",
                        disabled: started || finished && success,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base",
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "focus-link cursor-pointer",
                        onClick: function() {
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                            setAction("forgot");
                        },
                        children: "Forgot Password"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://shop.briogeohair.com/tools/recurring/get-subscription-access",
                className: " flex items-center justify-center mt-[45px]",
                children: "Manage Subscriptions"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/LoginForm/index.js


;// CONCATENATED MODULE: ./src/snippets/account/ForgotPasswordForm/ForgotPasswordForm.jsx
function ForgotPasswordForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ForgotPasswordForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ForgotPasswordForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ForgotPasswordForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function ForgotPasswordForm(param) {
    var setAction = param.setAction;
    var ref = (0,dist.useCustomerRecoverPassword)(), recoverPassword = ref.recoverPassword, started = ref.started, finished = ref.finished, errors = ref.errors, success = ref.success, reset = ref.reset, resetTimer = ref.resetTimer;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                reset && reset();
                clearTimeout(resetTimer.current);
            }, 2500);
        }
        return finished ? success ? "Email sent" : "Failed" : started ? "Sending email..." : "Reset Password";
    }, [
        started,
        success,
        finished
    ]);
    var recoverPasswordHandler = function() {
        var _ref = ForgotPasswordForm_asyncToGenerator(runtime_default().mark(function _callee(event) {
            var email;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        email = event.target.email;
                        _ctx.next = 4;
                        return recoverPassword({
                            email: email.value
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function recoverPasswordHandler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-4 py-[50px] lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "mx-auto w-full max-w-[432px] text-center",
            onSubmit: recoverPasswordHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-3 lg:mb-4",
                    children: " Forgot Password "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-small mb-7 font-light lg:text-base",
                    children: "We will send you an email to reset your password."
                }),
                (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function(err) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 text-[14px] leading-5 text-error",
                        children: err === "Unidentified customer" ? "Incorrect email / password" : "Something went wrong. Please try again."
                    }, err);
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "resetEmail",
                            placeholder: " ",
                            name: "email",
                            type: "email",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "resetEmail",
                            children: " Email "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    className: "button button--primary mb-[22px] w-full",
                    disabled: started || finished && success,
                    children: buttonText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "focus-link cursor-pointer",
                    onClick: function() {
                        return setAction("login");
                    },
                    children: "Cancel"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/ForgotPasswordForm/index.js


;// CONCATENATED MODULE: ./src/templates/account/login.jsx



function Login(param) {
    var action = param.action, setAction = param.setAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: action === "forgot" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm, {
            setAction: setAction
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
            setAction: setAction
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/RegisterForm/RegisterForm.jsx
function RegisterForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RegisterForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RegisterForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RegisterForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function RegisterForm() {
    var ref;
    var ref1 = (0,dist.useCustomerCreate)(), customerCreate = ref1.customerCreate, started = ref1.started, finished = ref1.finished, errors = ref1.errors, setErrors = ref1.setErrors, success = ref1.success, reset = ref1.reset, resetTimer = ref1.resetTimer;
    var sendRegisterEvent = (0,hooks/* useDataLayerActions */.KZ)().sendRegisterEvent;
    var buttonText = (0,react.useMemo)(function() {
        var newSuccess = success;
        var succeededWithError = errors === null || errors === void 0 ? void 0 : errors.some(function(e) {
            return e.indexOf("verify") > -1;
        });
        if (succeededWithError) {
            newSuccess = true;
        }
        ;
        if (finished && !succeededWithError) {
            resetTimer.current = setTimeout(function() {
                reset && reset();
                clearTimeout(resetTimer.current);
            }, 5000);
        }
        return finished ? newSuccess ? "Registered" : "Failed" : started ? "Registering..." : "Sign Up";
    }, [
        started,
        success,
        finished
    ]);
    var customerCreateHandler = function() {
        var _ref = RegisterForm_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var _target, firstName, lastName, email, password, passwordConfirm;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        _target = event.target, firstName = _target.firstName, lastName = _target.lastName, email = _target.email, password = _target.password, passwordConfirm = _target.passwordConfirm;
                        if (!(password.value !== passwordConfirm.value)) {
                            _ctx.next = 6;
                            break;
                        }
                        setErrors([
                            "Passwords do not match"
                        ]);
                        if (finished) {
                            resetTimer.current = setTimeout(function() {
                                reset && reset();
                                clearTimeout(resetTimer.current);
                            }, 5000);
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return customerCreate({
                            firstName: firstName.value,
                            lastName: lastName.value,
                            email: email.value,
                            password: password.value,
                            acceptsMarketing: false
                        });
                    case 8:
                        sendRegisterEvent();
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function customerCreateHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-4 py-[50px] lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "mx-auto w-full max-w-[432px] text-center",
            onSubmit: customerCreateHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-3 lg:mb-4",
                    children: "Sign Up"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-small mb-7 font-light lg:text-base",
                    children: [
                        "Already have an account? ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/account/login",
                            children: "Sign In"
                        })
                    ]
                }),
                errors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mb-[22px] w-full px-7 py-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute inset-0 h-full w-full bg-error opacity-10"
                        }),
                        (errors === null || errors === void 0 ? void 0 : errors.indexOf("Email has already been taken")) > -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-0 text-[14px] leading-5 text-error",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "This email address is already associated with an account. If this account is yours, please try ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "resetting your password"
                                    })
                                ]
                            })
                        }) : errors.map(function(err, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] leading-5 text-error ".concat(index == errors.length - 1 && "mb-0"),
                                children: err
                            }, "error-".concat(index));
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "registerFirstName",
                            placeholder: " ",
                            name: "firstName",
                            type: "text",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "registerFirstName",
                            children: " First Name "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "registerLastName",
                            placeholder: " ",
                            name: "lastName",
                            type: "text",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "registerLastName",
                            children: " Last Name "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: "".concat((errors === null || errors === void 0 ? void 0 : errors.find(function(e) {
                                return e.indexOf("Email") > -1;
                            })) ? "has-error" : ""),
                            id: "registerEmail",
                            placeholder: " ",
                            name: "email",
                            type: "email",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "registerEmail",
                            children: " Email Address "
                        }),
                        ((ref = errors === null || errors === void 0 ? void 0 : errors.find(function(e) {
                            return e.indexOf("Email") > -1;
                        })) === null || ref === void 0 ? void 0 : ref.length) ? errors.map(function(err) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "error",
                                children: err === "Email has already been taken" ? "Email is already being used" : err
                            });
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "registerPassword",
                            placeholder: " ",
                            name: "password",
                            type: "password",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "registePassword",
                            children: " Password "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: "".concat((errors === null || errors === void 0 ? void 0 : errors.indexOf("Passwords do not match")) > -1 ? "has-error" : ""),
                            id: "registerPasswordConfirm",
                            placeholder: " ",
                            name: "passwordConfirm",
                            type: "password",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "registePasswordConfirm",
                            children: " Confirm Password "
                        }),
                        (errors === null || errors === void 0 ? void 0 : errors.indexOf("Passwords do not match")) > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "error",
                            children: "Passwords do not match"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    className: "button button--primary mb-[22px] w-full",
                    disabled: started || finished && success,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-base",
                        children: buttonText
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/RegisterForm/index.js


;// CONCATENATED MODULE: ./src/templates/account/register.jsx


function Register(param) {
    var setAction = param.setAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {})
    });
}

;// CONCATENATED MODULE: ./src/templates/account/reset-password.jsx
function reset_password_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function reset_password_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                reset_password_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                reset_password_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function ResetPassword(param1) {
    var params = param1.params;
    var router = (0,dist.useRouter)();
    var ref = (0,react.useState)(""), password = ref[0], setPassword = ref[1];
    var ref1 = (0,react.useState)(""), passwordConfirm = ref1[0], setPasswordConfirm = ref1[1];
    var customerId = params.customerId, resetToken = params.resetToken;
    var resetUrl = "https://".concat("briogeo-hair-care.myshopify.com", "/account/reset/").concat(customerId, "/").concat(resetToken);
    var ref2 = (0,dist.useCustomerResetPassword)(), resetPassword = ref2.resetPassword, started = ref2.started, finished = ref2.finished, errors = ref2.errors, setErrors = ref2.setErrors, success = ref2.success, reset = ref2.reset, resetTimer1 = ref2.resetTimer;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer1.current = setTimeout(function() {
                reset && reset();
                clearTimeout(resetTimer1.current);
            }, 2000);
        }
        return finished ? success ? "Password Updated" : "Failed" : started ? "Updating.." : "Update Password";
    }, [
        started,
        success,
        finished
    ]);
    var resetPasswordHandler = function() {
        var _ref = reset_password_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var resetTimer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!(passwordConfirm !== password)) {
                            _ctx.next = 5;
                            break;
                        }
                        setErrors([
                            "Passwords do not match. Please try again."
                        ]);
                        resetTimer = setTimeout(function() {
                            reset();
                            clearTimeout(resetTimer);
                        }, 2500);
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return resetPassword({
                            password: password,
                            url: resetUrl
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resetPasswordHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-4 py-[50px] lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "mx-auto w-full max-w-[432px] text-center",
            onSubmit: resetPasswordHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-3 lg:mb-4",
                    children: " Reset Password "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-small mb-7 font-light lg:text-base",
                    children: "Enter a new password"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "password",
                            name: "password",
                            type: "password",
                            placeholder: " ",
                            minLength: "5",
                            required: true,
                            value: password,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setPassword(value);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "password",
                            children: " Password "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field mb-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: "".concat((errors === null || errors === void 0 ? void 0 : errors.indexOf("Passwords do not match")) > -1 ? "has-error" : ""),
                            name: "passwordConfirm",
                            placeholder: " ",
                            type: "password",
                            minLength: "5",
                            required: true,
                            value: passwordConfirm,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setPasswordConfirm(value);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "passwordConfirm",
                            children: " Confirm Password "
                        })
                    ]
                }),
                (errors === null || errors === void 0 ? void 0 : errors.length) ? errors.map(function(err) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles.formError,
                        children: err === "Unidentified customer" ? "Incorrect email / password" : "Something went wrong. Please try again."
                    }, err);
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "button button--primary mb-[22px] w-full cursor-pointer",
                    disabled: started || finished && success,
                    children: buttonText
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/layouts/AccountLayout.jsx
var AccountLayout = __webpack_require__(8387);
// EXTERNAL MODULE: ./src/snippets/icons/Close.jsx
var Close = __webpack_require__(54059);
;// CONCATENATED MODULE: ./src/snippets/account/AddressForm/useCountries.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function useCountries_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCountries_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCountries_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCountries_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var useCountries = function(props) {
    var ref = (0,react.useState)({
        countryNames: [],
        countryNamesData: []
    }), countriesData = ref[0], setCountriesData = ref[1];
    var firstCountries = Array.isArray(props === null || props === void 0 ? void 0 : props.firstCountries) ? props === null || props === void 0 ? void 0 : props.firstCountries : [];
    var awaitCountries = function() {
        var _ref = useCountries_asyncToGenerator(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getCountries({
                            firstCountries: firstCountries
                        });
                    case 3:
                        data = _ctx.sent;
                        setCountriesData({
                            countryNames: data.finalNameList,
                            countryNamesData: data.finalDataList
                        });
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function awaitCountries() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (countriesData.countryNames.length && countriesData.countryNamesData.length) return;
        awaitCountries();
    }, []);
    return countriesData;
};
var getCountries = function() {
    var _ref = useCountries_asyncToGenerator(runtime_default().mark(function _callee(param) {
        var _firstCountries, firstCountries, data, initialDataList, firstCountriesObj, initialNameList, finalDataList, finalNameList;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _firstCountries = param.firstCountries, firstCountries = _firstCountries === void 0 ? [] : _firstCountries;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return __webpack_require__.e(/* import() */ 2582).then(__webpack_require__.t.bind(__webpack_require__, 3036, 19));
                case 4:
                    data = _ctx.sent;
                    initialDataList = data.default;
                    firstCountriesObj = firstCountries.reduce(function(obj, value) {
                        obj[value] = {};
                        return obj;
                    }, {});
                    initialNameList = initialDataList.map(function(item) {
                        if (firstCountriesObj[item.countryName]) {
                            firstCountriesObj[item.countryName] = item;
                        }
                        return item.countryName;
                    });
                    finalDataList = _toConsumableArray(Object.values(firstCountriesObj)).concat(_toConsumableArray(initialDataList));
                    finalNameList = _toConsumableArray(Object.keys(firstCountriesObj)).concat(_toConsumableArray(initialNameList));
                    return _ctx.abrupt("return", {
                        finalDataList: finalDataList,
                        finalNameList: finalNameList
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    throw new Error(_ctx.t0);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }));
    return function getCountries(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utilities/Helper.js
var Helper = __webpack_require__(41717);
;// CONCATENATED MODULE: ./src/snippets/account/AddressForm/AddressForm.jsx
function AddressForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddressForm_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AddressForm_arrayLikeToArray(arr);
}
function AddressForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddressForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddressForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddressForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddressForm_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AddressForm_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddressForm_toConsumableArray(arr) {
    return AddressForm_arrayWithoutHoles(arr) || AddressForm_iterableToArray(arr) || AddressForm_unsupportedIterableToArray(arr) || AddressForm_nonIterableSpread();
}
function AddressForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddressForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddressForm_arrayLikeToArray(o, minLen);
}






var UK_PROVINCES = [
    "British Forces",
    "England",
    "Northern Ireland",
    "Scotland",
    "Wales", 
];
function AddressForm(param1) {
    var address = param1.address, closeForm = param1.closeForm, addressIsDefault = param1.addressIsDefault;
    var ref9 = useCountries({
        firstCountries: [
            "United States",
            "Canada",
            "United Kingdom",
            "United Arab Emirates", 
        ]
    }), countryNames = ref9.countryNames, countryNamesData = ref9.countryNamesData;
    var ref1 = (0,dist.useCustomerCreateAddress)(), createAddress = ref1.createAddress, createErrors = ref1.errors, createSetErrors = ref1.setErrors;
    var ref2 = (0,dist.useCustomerUpdateAddress)(), updateAddress = ref2.updateAddress, updateErrors = ref2.errors, updateSetErrors = ref2.setErrors;
    var ref3 = (0,react.useState)(false), mounted = ref3[0], setMounted = ref3[1];
    var ref4 = (0,react.useState)(addressIsDefault || false), isDefaultAddress = ref4[0], setIsDefaultAddress = ref4[1];
    var ref5 = (0,react.useState)(null), selectedCountryIndex = ref5[0], setSelectedCountryIndex = ref5[1];
    var ref6 = (0,react.useState)([]), provinceNames = ref6[0], setProvinceNames = ref6[1];
    var ref7 = (0,react.useState)(false), provinceSelected = ref7[0], setProvinceSelected = ref7[1];
    var ref8 = (0,react.useState)({
        firstName: (address === null || address === void 0 ? void 0 : address.firstName) || "",
        lastName: (address === null || address === void 0 ? void 0 : address.lastName) || "",
        address1: (address === null || address === void 0 ? void 0 : address.address1) || "",
        address2: (address === null || address === void 0 ? void 0 : address.address2) || "",
        city: (address === null || address === void 0 ? void 0 : address.city) || "",
        province: (address === null || address === void 0 ? void 0 : address.province) || "",
        country: (address === null || address === void 0 ? void 0 : address.country) || "United States",
        zip: (address === null || address === void 0 ? void 0 : address.zip) || "",
        phone: (address === null || address === void 0 ? void 0 : address.phone) || ""
    }), addressForm = ref8[0], setAddressForm = ref8[1];
    var clearForm = function() {
        setAddressForm({
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            country: "",
            zip: "",
            phone: ""
        });
        setIsDefaultAddress(false);
    };
    // handles both, createAddress and updateAddress
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = AddressForm_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var offset, header, newAddress, updatedAddress;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (e.target.reportValidity()) {
                            _ctx.next = 6;
                            break;
                        }
                        offset = (0,Helper/* getOffset */.os)(e.target.querySelector(":invalid"));
                        header = document.querySelector(".site-header");
                        window.scrollTo({
                            top: offset.top - header.clientHeight,
                            behavior: "smooth"
                        });
                        return _ctx.abrupt("return");
                    case 6:
                        if (address) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 9;
                        return createAddress({
                            isDefault: isDefaultAddress,
                            address: addressForm
                        });
                    case 9:
                        newAddress = _ctx.sent;
                        if (newAddress) {
                            clearForm();
                            closeForm && closeForm(null);
                        }
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.next = 15;
                        return updateAddress({
                            id: address === null || address === void 0 ? void 0 : address.id,
                            isDefault: isDefaultAddress,
                            address: addressForm
                        });
                    case 15:
                        updatedAddress = _ctx.sent;
                        if (updatedAddress) {
                            clearForm();
                            closeForm && closeForm(null);
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addressForm,
        isDefaultAddress,
        address
    ]);
    var setCountryIndexOnAddressChange = function() {
        if (!countryNames.length) return;
        var countryIndex = 0;
        countryNames.find(function(item, index) {
            if (item === (address === null || address === void 0 ? void 0 : address.country)) {
                countryIndex = index;
                return true;
            }
            return false;
        });
        setSelectedCountryIndex(countryIndex);
    };
    var setProvincesOnCountryChange = function() {
        var ref;
        if (selectedCountryIndex === null) return;
        var country = countryNamesData[selectedCountryIndex];
        var provincesList = [];
        country.countryName === "United Kingdom" ? provincesList = UK_PROVINCES : provincesList = country === null || country === void 0 ? void 0 : (ref = country.regions) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.name;
        });
        provincesList = [
            ""
        ].concat(AddressForm_toConsumableArray(provincesList));
        if (mounted || !addressForm.province) {
            setAddressForm(_objectSpread({}, addressForm, {
                province: !provincesList || provincesList.length < 1 ? null : provincesList[0]
            }));
        }
        /* provincesList.find((item, index) => {
      if (item === address?.province) {
        setProvinceSelected(true);
        return true;
      }
      return false;
    }) */ setProvinceSelected(addressForm.province);
        setProvinceNames(provincesList || []);
        setMounted(true);
    };
    (0,react.useEffect)(function() {
        setCountryIndexOnAddressChange();
    }, [
        address,
        countryNames
    ]);
    (0,react.useEffect)(function() {
        setProvincesOnCountryChange();
    }, [
        selectedCountryIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "-mx-4 flex flex-wrap",
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "firstName",
                            placeholder: " ",
                            name: "firstName",
                            type: "text",
                            value: addressForm.firstName,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    firstName: value
                                }));
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "firstName",
                            children: "First Name"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "lastName",
                            placeholder: " ",
                            name: "lastName",
                            type: "text",
                            value: addressForm.lastName,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    lastName: value
                                }));
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "lastName",
                            children: "Last Name"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "address1",
                            placeholder: " ",
                            name: "address1",
                            type: "text",
                            value: addressForm.address1,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    address1: value
                                }));
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "address1",
                            children: "Address 1"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "address2",
                            placeholder: " ",
                            name: "address2",
                            type: "text",
                            value: addressForm.address2,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    address2: value
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "address2",
                            children: "Address 2"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "city",
                            placeholder: " ",
                            name: "city",
                            type: "text",
                            value: addressForm.city,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    city: value
                                }));
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "city",
                            children: "City"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 hidden w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "selected",
                            name: "country",
                            id: "country",
                            placeholder: " ",
                            defaultValue: addressForm.country,
                            onChange: function(param) {
                                var _target = param.target, index = _target.value;
                                if (index === selectedCountryIndex) return;
                                setSelectedCountryIndex(index);
                                setAddressForm(_objectSpread({}, addressForm, {
                                    country: countryNames[index]
                                }));
                            },
                            children: countryNames.map(function(country, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: index,
                                    children: country
                                }, country + index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "country",
                            children: "Country"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field select-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "".concat(provinceSelected ? "selected" : ""),
                            name: "province",
                            id: "province",
                            placeholder: " ",
                            defaultValue: addressForm.province,
                            onChange: function(param) {
                                var value = param.target.value;
                                setProvinceSelected(value);
                                setAddressForm(_objectSpread({}, addressForm, {
                                    province: value
                                }));
                            },
                            required: true,
                            children: provinceNames.map(function(province, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: province,
                                    selected: province === addressForm.province,
                                    disabled: !province,
                                    children: province
                                }, province + index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "province",
                            children: "State"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "zip",
                            placeholder: " ",
                            name: "zip",
                            type: "text",
                            value: addressForm.zip,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    zip: value
                                }));
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "zip",
                            children: "Zip Code"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 md-:w-1/2 lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "phone",
                            placeholder: " ",
                            name: "phone",
                            type: "text",
                            value: addressForm.phone,
                            onChange: function(param) {
                                var value = param.target.value;
                                return setAddressForm(_objectSpread({}, addressForm, {
                                    phone: value
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "phone",
                            children: "Phone Number"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: "mr-3",
                            id: "isDefaultAddress",
                            name: "isDefaultAddress",
                            type: "checkbox",
                            checked: isDefaultAddress,
                            onChange: function(param) {
                                var checked = param.target.checked;
                                return setIsDefaultAddress(checked);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "isDefaultAddress",
                            children: "Set as default"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-7 w-full px-4 text-center md-:w-1/2 md-:text-left lg:max-w-[358px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-field",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "submit",
                            className: "button button--secondary mb-6 w-full md-:mb-[22px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base",
                                children: "Save"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "focus-link",
                            onClick: closeForm,
                            children: "Cancel"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/account/AddressForm/index.js


;// CONCATENATED MODULE: ./src/templates/account/address-book.jsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







function AddressBook() {
    var defaultAddress = (0,dist.useCustomerDefaultAddress)();
    var _ref = (0,dist.useCustomerAddresses)(), addresses = _ref.addresses, status = _objectWithoutProperties(_ref, [
        "addresses"
    ]);
    var _ref1 = (0,dist.useCustomerDeleteAddress)(), deleteAddress = _ref1.deleteAddress, deleteStatus = _objectWithoutProperties(_ref1, [
        "deleteAddress"
    ]);
    var removeAddress = function(addr) {
        deleteAddress({
            id: addr.id
        }, function() {
            console.log("Address removed!");
        });
    };
    var ref = (0,react.useState)(null), selectedAddress = ref[0], setSelectedAddress = ref[1];
    var ref1 = (0,react.useState)(false), createAddress = ref1[0], setCreateAddress = ref1[1];
    if (status.started) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: " Loading Addresses ... "
            })
        });
    }
    if (createAddress) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "address-book px-4 pt-3 pb-10 lg:px-0 lg:py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-6 md-:mb-9",
                        children: "Add Address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm, {
                        closeForm: function() {
                            setCreateAddress(false);
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        }
                    })
                ]
            })
        });
    }
    if (!defaultAddress || !(addresses === null || addresses === void 0 ? void 0 : addresses.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "address-book px-4 pt-3 pb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-4",
                        children: "Addresses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "-mx-3 my-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "w-full px-3 md-:w-1/2 lg:max-w-[408px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "address-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        return setCreateAddress(true);
                                    },
                                    className: "focus-link m-auto flex flex-col items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mb-2.5 rotate-45 transform md-:mb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-small",
                                            children: "add new address"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
    if (selectedAddress) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "address-book px-4 pt-3 pb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-4",
                        children: "Addresses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm, {
                        address: selectedAddress,
                        closeForm: function() {
                            setSelectedAddress(null);
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        },
                        addressIsDefault: defaultAddress.id.split("?")[0] === selectedAddress.id.split("?")[0]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "address-book px-4 pt-3 pb-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-4",
                    children: "Addresses"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "-mx-3 my-0 flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "w-full px-3 md-:w-1/2 lg:max-w-[408px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "address-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-2",
                                                children: [
                                                    defaultAddress.firstName,
                                                    " ",
                                                    defaultAddress.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-1",
                                                children: [
                                                    defaultAddress.address1,
                                                    ", ",
                                                    defaultAddress.address2
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mb-1",
                                                children: [
                                                    defaultAddress.city,
                                                    ",",
                                                    " ",
                                                    defaultAddress.provinceCode || defaultAddress.province,
                                                    " ",
                                                    defaultAddress.zip
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-1",
                                                children: defaultAddress.country
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0 font-hafferBold text-[14px] leading-5 text-primary-2",
                                        children: "Default Address"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "button button--secondary mr-8 min-w-[135px]",
                                                onClick: function() {
                                                    return setSelectedAddress(defaultAddress);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-base",
                                                    children: "edit"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "focus-link",
                                                onClick: function() {
                                                    return removeAddress(defaultAddress);
                                                },
                                                children: "delete"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, defaultAddress.id),
                        addresses === null || addresses === void 0 ? void 0 : addresses.map(function(address) {
                            var address1 = address.address1, address2 = address.address2, city = address.city, company = address.company, country = address.country, firstName = address.firstName, id = address.id, lastName = address.lastName, phone = address.phone, province = address.province, provinceCode = address.provinceCode, zip = address.zip;
                            var isDefaultAddress = defaultAddress.id.split("?")[0] === id.split("?")[0];
                            return !isDefaultAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "w-full px-3 md-:w-1/2 lg:max-w-[408px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "address-item",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mb-2",
                                                    children: [
                                                        firstName,
                                                        " ",
                                                        lastName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mb-1",
                                                    children: [
                                                        address1,
                                                        ", ",
                                                        address2
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mb-1",
                                                    children: [
                                                        city,
                                                        ", ",
                                                        provinceCode || province,
                                                        " ",
                                                        zip
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-1",
                                                    children: country
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "button button--secondary mr-8 min-w-[135px]",
                                                    onClick: function() {
                                                        setSelectedAddress(address);
                                                        window.scrollTo({
                                                            top: 0,
                                                            behavior: "smooth"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-base",
                                                        children: "edit"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "focus-link",
                                                    onClick: function() {
                                                        return removeAddress(address);
                                                    },
                                                    children: "delete"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "w-full px-3 md-:w-1/2 lg:max-w-[408px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "address-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        setCreateAddress(true);
                                        window.scrollTo({
                                            top: 0,
                                            behavior: "smooth"
                                        });
                                    },
                                    className: "focus-link m-auto flex flex-col items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mb-2.5 rotate-45 transform md-:mb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-small",
                                            children: "add new address"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/edit-profile.jsx



function EditProfile(param) {
    var customer = param.customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: " Edit Profile "
            })
        })
    });
}

// EXTERNAL MODULE: ./src/snippets/account/AccountNav/index.js + 1 modules
var AccountNav = __webpack_require__(77350);
// EXTERNAL MODULE: ./src/snippets/icons/ArrowLeft.jsx
var ArrowLeft = __webpack_require__(92301);
// EXTERNAL MODULE: ./src/snippets/icons/ArrowRight.jsx
var ArrowRight = __webpack_require__(14604);
// EXTERNAL MODULE: ./src/templates/account/OrderItem.jsx
var OrderItem = __webpack_require__(49349);
;// CONCATENATED MODULE: ./src/templates/account/orders.jsx
function orders_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = orders_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function orders_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








function Orders() {
    var ref = (0,dist.useCustomerAuth)(), customerInit = ref.customerInit, customer = ref.customer;
    var router = (0,dist.useRouter)();
    var _ref = (0,dist.useCustomerOrders)({
        perPage: 5
    }), orders = _ref.orders, page = _ref.page, hasNext = _ref.hasNext, hasPrevious = _ref.hasPrevious, getNext = _ref.getNext, getPrevious = _ref.getPrevious, status = orders_objectWithoutProperties(_ref, [
        "orders",
        "page",
        "hasNext",
        "hasPrevious",
        "getNext",
        "getPrevious"
    ]);
    (0,react.useEffect)(function() {
        if (customer) {
            router.push("/pages/my-profile");
        }
    }, []);
    return null;
    if (status.started) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order-history max-w-[890px] px-4 pt-2 pb-6 lg:p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Loading Orders ..."
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "order-history max-w-[1000px] px-4 pt-4 pb-6 lg:p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mb-8 lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountNav/* AccountNav */.f, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "subscription-portal-container relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bottom-account-gradient"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "yotpo-widget-instance",
                    "data-yotpo-instance-id": "892619"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-history-container relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mt-2 mb-2 lg:mb-8",
                            children: "Order History"
                        }),
                        (orders === null || orders === void 0 ? void 0 : orders.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-list-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md-:w-[18%]",
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md-:w-1/5",
                                            children: "Order"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md-:w-1/5",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md-:w-1/5",
                                            children: "Total"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-list",
                                    children: orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem/* default */.Z, {
                                            orderData: order
                                        }, order.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pagination",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "mr-5",
                                            onClick: function() {
                                                window.scrollTo({
                                                    top: 0,
                                                    behavior: "smooth"
                                                });
                                                getPrevious();
                                            },
                                            disabled: !hasPrevious,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* ArrowLeft */.X, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "",
                                            onClick: function() {
                                                window.scrollTo({
                                                    top: 0,
                                                    behavior: "smooth"
                                                });
                                                getNext();
                                            },
                                            disabled: !hasNext,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        (orders === null || orders === void 0 ? void 0 : orders.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base",
                            children: "There's no order."
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/order.jsx
function order_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = order_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function order_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Order() {
    var ref14, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,dist.useRouter)();
    // fetch the full order including line-items
    var _ref = (0,dist.useCustomerOrder)({
        id: router.query.id
    }), order = _ref.order, status = order_objectWithoutProperties(_ref, [
        "order"
    ]);
    if (status.started) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: " Loading Order ... "
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    children: [
                        " Order #",
                        order === null || order === void 0 ? void 0 : order.orderNumber,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Order Status"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : order.fulfillmentStatus
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Order Status"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : order.processedAt
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Payment Status"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : order.financialStatus
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Shipping Address"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                order === null || order === void 0 ? void 0 : (ref14 = order.shippingAddress) === null || ref14 === void 0 ? void 0 : ref14.firstName,
                                " ",
                                order === null || order === void 0 ? void 0 : (ref1 = order.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : (ref2 = order.shippingAddress) === null || ref2 === void 0 ? void 0 : ref2.address1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : (ref3 = order.shippingAddress) === null || ref3 === void 0 ? void 0 : ref3.address2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : (ref4 = order.shippingAddress) === null || ref4 === void 0 ? void 0 : ref4.country
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: order === null || order === void 0 ? void 0 : (ref5 = order.shippingAddress) === null || ref5 === void 0 ? void 0 : ref5.phone
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Order Items"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: order === null || order === void 0 ? void 0 : (ref6 = order.lineItems) === null || ref6 === void 0 ? void 0 : ref6.map(function(lineItem, index) {
                                var ref, ref12, ref13;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : (ref12 = ref.product) === null || ref12 === void 0 ? void 0 : ref12.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: lineItem === null || lineItem === void 0 ? void 0 : (ref13 = lineItem.variant) === null || ref13 === void 0 ? void 0 : ref13.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Qty: ",
                                                lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: "Order Total"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Subtotal: $",
                                Number.parseFloat((order === null || order === void 0 ? void 0 : (ref7 = order.subtotalPriceV2) === null || ref7 === void 0 ? void 0 : ref7.amount) || 0, 2)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Refunded: $",
                                Number.parseFloat((order === null || order === void 0 ? void 0 : (ref8 = order.totalRefundedV2) === null || ref8 === void 0 ? void 0 : ref8.amount) || 0, 2)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Shipping: $",
                                Number.parseFloat((order === null || order === void 0 ? void 0 : (ref9 = order.totalShippingPriceV2) === null || ref9 === void 0 ? void 0 : ref9.amount) || 0, 2)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Tax: $",
                                Number.parseFloat((order === null || order === void 0 ? void 0 : (ref10 = order.totalTaxV2) === null || ref10 === void 0 ? void 0 : ref10.amount) || 0, 2)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Total: $",
                                Number.parseFloat((order === null || order === void 0 ? void 0 : (ref11 = order.totalPriceV2) === null || ref11 === void 0 ? void 0 : ref11.amount) || 0, 2)
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
Order.displayName = "OrderDetails";

;// CONCATENATED MODULE: ./src/snippets/account/AccountNav/SwellPointBalance.jsx



function SwellPointBalance(param) {
    var customer = param.customer;
    var ref;
    var ref1 = (0,react.useState)(0), points = ref1[0], setPoints = ref1[1];
    var customerDetails = (0,hooks/* useCustomerDetails */.SZ)({
        email: customer === null || customer === void 0 ? void 0 : customer.email
    }).customerDetails;
    (0,react.useEffect)(function() {
        setPoints(customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance);
    }, [
        customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.points_balance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            customer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "swell-customer-identification",
                "data-authenticated": "true",
                "data-email": customer === null || customer === void 0 ? void 0 : customer.email,
                "data-id": customer === null || customer === void 0 ? void 0 : (ref = customer.id) === null || ref === void 0 ? void 0 : ref.replace("gid://shopify/Customer/", ""),
                "data-tags": '"[]"',
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: points
            })
        ]
    });
}
/* harmony default export */ var AccountNav_SwellPointBalance = (SwellPointBalance);

;// CONCATENATED MODULE: ./src/templates/account/rewards.jsx




function Rewards(param) {
    var params = param.params;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "account-rewards px-4 pt-3 pb-10 lg:max-w-[790px] lg:p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/account/orders",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "focus-link text-small mb-3 lg:hidden",
                        children: "Back to Order History"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-4 lg:mb-14",
                    children: "Rewards"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-9 flex w-full flex-col items-center bg-[#EDF0F5] py-6 px-16 lg:py-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "mb-4 lg:mb-5",
                            children: "My Rewards"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "mb-4 inline-flex flex-col items-center border border-quinary-2 lg:mb-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "bg-quinary-2 px-8 py-1.5 text-base",
                                    children: "Points Balance"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pt-1 pb-2 font-hafferBold text-[24px] leading-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountNav_SwellPointBalance, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center font-light",
                            children: "Earn more rewards with every purchase!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/pages/rewards",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "button button--secondary mx-auto block w-full max-w-[270px] text-center text-[16px] leading-[26px] no-underline",
                        children: "how to earn"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/referral.jsx





function Referral() {
    var ref;
    var settings = (0,dist.useSettings)();
    var referralRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    var i = 0;
    var buildReferral = function() {
        i++;
        if (i > 6 || document.querySelector(".account-referral .swell-referral-content-container")) {
            return;
        }
        if (typeof Swell === "undefined") {
            var t = window.setTimeout(function() {
                buildReferral();
                clearTimeout(t);
            }, 500);
            return;
        }
        Swell.Referral.initializeReferral(".account-referral", {
            localization: {
                referralRegisterHeading: "Refer A Friend",
                referralCopyLinkHeading: "Copy Link",
                referralReferHeading: "Refer A Friend",
                referralRegisterFormDetails: "Enter your email below."
            }
        });
    };
    (0,react.useEffect)(function() {
        setLoaded(true);
    }, []);
    (0,react.useEffect)(function() {
        if (referralRef.current) {
            buildReferral();
        }
        document.addEventListener("swell:setup", buildReferral);
        return function() {
            document.removeEventListener("swell:setup", buildReferral);
        };
    }, [
        loaded,
        referralRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 pt-3 pb-10 lg:p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/account/orders",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "focus-link text-small mb-3 lg:hidden",
                        children: "Back to Order History"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-8 lg:mb-7",
                    children: "Refer A Friend"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap",
                    children: [
                        (settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.referFriendImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-9 w-full md-:mb-0 md-:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: settings.account.referFriendImage.src,
                                alt: settings.account.referFriendImage.alt,
                                width: "1000",
                                height: "1000"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "account-referral w-full md-:w-1/2",
                            ref: referralRef
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/templates/account/index.js









/* harmony default export */ var account = ({
    activate: null,
    // logged out
    login: Login,
    register: Register,
    "reset-password": ResetPassword,
    // logged in
    "address-book": AddressBook,
    "edit-profile": EditProfile,
    orders: Orders,
    order: Order,
    rewards: Rewards,
    referral: Referral
});


/***/ })

}]);